import { Link } from 'react-router-dom';
import { Lock, Crown, Zap, Star } from 'lucide-react';
import { Button } from './ui/button';

const UpgradePrompt = ({ 
  feature, 
  currentTier = 'free', 
  requiredTier = 'starter',
  title,
  description 
}) => {
  const tierInfo = {
    starter: { name: 'Starter', price: '£12.99/month', icon: Star, color: '#D4AF37' },
    pro: { name: 'Pro', price: '£25.99/month', icon: Zap, color: '#D4AF37' },
    elite: { name: 'Elite', price: '£79.99/month', icon: Crown, color: '#D4AF37' }
  };

  const required = tierInfo[requiredTier] || tierInfo.starter;
  const Icon = required.icon;

  const defaultTitles = {
    content: 'Content Library',
    community: 'DJ Community',
    coaching: 'Coaching Section',
    ebooks: 'eBooks',
    sfx_packs: 'SFX Packs'
  };

  const defaultDescriptions = {
    content: 'Access our complete library of DJ lessons, resources, and tutorials.',
    community: 'Join our community of DJs, share mixes, get feedback, and connect with others.',
    coaching: 'Get personalized 1:1 coaching sessions and expert feedback on your mixes.',
    ebooks: 'Download exclusive eBooks to accelerate your DJ journey.',
    sfx_packs: 'Access premium SFX packs to enhance your sets.'
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-4" data-testid="upgrade-prompt">
      <div className="glass-panel rounded-2xl border p-8 md:p-12 max-w-lg w-full text-center">
        <div className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center" style={{ background: 'rgba(212, 175, 55, 0.2)' }}>
          <Lock size={40} style={{ color: '#D4AF37' }} />
        </div>
        
        <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#ffffff' }}>
          {title || defaultTitles[feature] || 'Premium Feature'}
        </h2>
        
        <p className="text-muted-foreground mb-6">
          {description || defaultDescriptions[feature] || 'This feature requires a membership upgrade.'}
        </p>

        <div className="p-4 rounded-xl mb-6" style={{ background: 'rgba(212, 175, 55, 0.1)' }}>
          <div className="flex items-center justify-center gap-2 mb-2">
            <Icon size={20} style={{ color: required.color }} />
            <span className="font-semibold" style={{ color: required.color }}>
              {required.name} Membership Required
            </span>
          </div>
          <p className="text-sm text-muted-foreground">
            Starting at {required.price}
          </p>
        </div>

        <div className="space-y-3">
          <Link to="/pricing" className="block">
            <Button 
              className="w-full rounded-full py-6 text-lg font-semibold transition-all hover:scale-105"
              style={{ background: '#D4AF37', color: '#141414' }}
            >
              Upgrade Now
            </Button>
          </Link>
          <Link to="/dashboard" className="block">
            <Button variant="outline" className="w-full">
              Back to Dashboard
            </Button>
          </Link>
        </div>

        <p className="text-xs text-muted-foreground mt-6">
          Your current tier: <span className="font-semibold capitalize">{currentTier}</span>
        </p>
      </div>
    </div>
  );
};

export default UpgradePrompt;
